import { apiV3 } from 'services/apiV3';
import { payex } from 'services/payex';

export const UserRepository = {
  async userExists({ email, token = '' }: { email: string; token?: string }) {
    try {
      const { users } = apiV3;

      await users.userExists({ email, token });

      return true;
    } catch (_error) {
      return false;
    }
  },

  async emailLookup({ email }: { email: string }) {
    try {
      return await payex.users.emailLookup({ email });
    } catch (_error) {
      return null;
    }
  },

  async emailLookupLastPayment({ email }: { email: string }) {
    try {
      return await payex.users.emailLookupLastPayment({ email });
    } catch (_error) {
      return null;
    }
  },
};
